function CancelIcon() {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' viewBox='0 0 12 12'>
      <g fill='#000' clipPath='url(#clip0_3559_8704)'>
        <path d='M.586 12a.587.587 0 01-.414-1L11 .172a.586.586 0 01.829.828L1 11.83A.583.583 0 01.586 12z' />
        <path d='M11.414 12A.584.584 0 0111 11.83L.172 1A.586.586 0 111 .172L11.83 11a.585.585 0 01-.415 1z' />
      </g>
      <defs>
        <clipPath id='clip0_3559_8704'>
          <path fill='#fff' d='M0 0H12V12H0z' />
        </clipPath>
      </defs>
    </svg>
  );
}

export default CancelIcon;
